import { minLength, maxLength, required, numeric } from 'vuelidate/lib/validators'
import { slugValidator, slugAsyncValidator } from '@/utils/validations/validations'
import hotelsSlugsQuery from '@/services/gql/types/Hotels/queries/hotelsSlugs.gql'
export default ({ id, ctx, isNew, certificateRequired }) => {
  const isUnique = async value => {
    return await slugAsyncValidator(value, id, hotelsSlugsQuery, ctx, 'hotels')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    // rooms
    fields: {
      title: {
        required,
        maxLength: maxLength(100)
      },
      description: {
        required
      },
      shortDescription: {
        required
      },
      cityId: {
        required
      },
      typeId: {
        required
      },
      checkOutTime: {
        required
      },
      checkInTime: {
        required
      },
      images: {
        required
      },
      slug: (() => {
        if (isNew) {
          return false
        }
        return {
          required,
          slugValidator,
          isUnique
        }
      })(),
      certificateNumber: (() => {
        if (!certificateRequired) {
          return false
        }
        return {
          required,
          minLength: minLength(4),
          maxLength: maxLength(25)
        }
      })(),
      address: {
        lat: { required },
        lon: { required },
        address: { required }
      },
      roomTypes: {
        required,
        $each: {
          title: {
            required,
            maxLength: maxLength(100)
          },
          images: {
            required
          },
          description: {
            required
          },
          maxAdults: {
            required
          },
          maxChildren: {
            required
          },
          maxGuests: {
            required
          },
          basePrice: {
            required,
            numeric
          }
        }
      },
      rooms: {
        $each: {
          number: {
            required
          },
          floor: {
            required
          },
          roomTypeId: {
            required
          }
        }
      }
    }
  }
}
